export default __webpack_public_path__ + "static/media/google-logo.01a4c398.svg";